export const categorylist = [
  {
    id: 1,
    group: "DOUCEUR TRADITIONNELLE",
    img: "assets/img/products/Amande.JPG",
    description: "",
    createdon: "25 May 2023",
    status: "Active",
  },
  {
    id: 2,
    group: "CREMEUX",
    img: "assets/img/products/AMPI.jpg",
    description: "",
    createdon: "24 Jun 2023",
    status: "Active",
  },
  {
    id: 3,
    group: "GATEAUX",
    img: "assets/img/products/BOU2.jpg",
    description: "",
    createdon: "23 Jul 2023",
    status: "Active",
  },
  {
    id: 4,
    group: "SALÉ CHAUD",
    img: "assets/img/products/DAVI.jpg",
    description: "",
    createdon: "22 Aug 2023",
    status: "Active",
  },
  {
    id: 5,
    group: "SALÉ FROID",
    img: "assets/img/products/product4.JPG",
    description: "",
    createdon: "21 Sep 2023",
    status: "Active",
  },
  {
    id: 7,
    group: "COLLECTION ÉLÉGANCE",
    img: "assets/img/products/EIPM.JPG",
    description: "",
    createdon: "20 Sep 2023",
    status: "Active",
  },
  {
    id: 8,
    group: "COLLECTION PRESTIGE",
    img: "assets/img/products/EGAS.JPG",
    description: "",
    createdon: "20 Sep 2023",
    status: "Active",
  },
];
